import React from "react"
import Icon from "./Icon"

export const Check = ({ href, name, className }) => (
  <Icon name="check" className={className} />
)

export default Check
